import * as React from 'react';
import {Button as MuiButton}  from '@mui/material';

const Button = (props: any) => {
    return <MuiButton variant="contained" {...props} />
}

export default Button;